<template>
  <div style="padding:16px">

    <!-- 头部部分 -->
    <div ref="search_d">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="18">
          <el-button type="primary" @click="newBtn">新建</el-button>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="请输入内容" v-model="queryInfo.condition.queryKey" class="input-with-select" clearable>
            <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
          </el-input>
        </el-col>
      </el-row>
    </div>

    <!-- 表格部分 -->
    <div>
      <el-table border ref="table" :data="tableData" tooltip-effect="dark" style="width: 100%" :height="height">
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>

                  <!-- <el-table-column label="" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.id }}</template>
          </el-table-column>
          <el-table-column label="消息唯一id" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.transactionId }}</template>
          </el-table-column> -->
          <!-- <el-table-column label="消息归属人编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.userCode }}</template>
          </el-table-column>
          <el-table-column label="消息归属人名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.userName }}</template>
          </el-table-column> -->
          <!-- <el-table-column label="消息接收人编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.receiverCode }}</template>
          </el-table-column>
          <el-table-column label="消息接收人名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.receiverName }}</template>
          </el-table-column>
          <el-table-column label="消息接收人logo" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.receiverLogo }}</template>
          </el-table-column> -->
          <!-- <el-table-column label="消息发送人编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.senderCode }}</template>
          </el-table-column> -->
          <el-table-column label="圈子名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.groupName }}</template>
          </el-table-column>
          <el-table-column label="消息发送人名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.senderName }}</template>
          </el-table-column>
          <el-table-column label="消息发送人图片" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-avatar shape="square" :size="50" :src="scope.row.senderLogo"></el-avatar>
            </template> 
          </el-table-column>
          <!-- <el-table-column label="聊天对象编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.chatObjectCode }}</template>
          </el-table-column>
          <el-table-column label="聊天对象名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.chatObjectName }}</template>
          </el-table-column>
          <el-table-column label="聊天对象的logo" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.chatObjectLogo }}</template>
          </el-table-column>
          <el-table-column label="群聊编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.groupCode }}</template>
          </el-table-column> -->
          
          <!-- <el-table-column label="群聊图片" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.groupLogo }}</template>
          </el-table-column> -->
          <el-table-column label="消息类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.messageType }}</template>
          </el-table-column>
          <!-- <el-table-column label="传输类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.transType }}</template>
          </el-table-column> -->
          <el-table-column label="消息内容" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.messageContent }}</template>
          </el-table-column>
          <el-table-column label="发送时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.sendTime }}</template>
          </el-table-column>
          <el-table-column label="接收时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.receiveTime }}</template>
          </el-table-column>
          <!-- <el-table-column label="是否已读" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.isRead }}</template>
          </el-table-column>
          <el-table-column label="消息状态" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.messageStatus }}</template>
          </el-table-column>
          <el-table-column label="群成员数量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberCount }}</template>
          </el-table-column>
          <el-table-column label="群管理员编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.manageUserCode }}</template>
          </el-table-column>
          <el-table-column label="群管理员名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.manageUserName }}</template>
          </el-table-column>
          <el-table-column label="房间号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.roomId }}</template>
          </el-table-column>
          <el-table-column label="聊天对象类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.chatObjectType }}</template>
          </el-table-column>
          <el-table-column label="消息类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.serviceType }}</template>
          </el-table-column>
          <el-table-column label="已读数量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.readCount }}</template>
          </el-table-column>
          <el-table-column label="未读数量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.noReadCount }}</template>
          </el-table-column>
          <el-table-column label="本地url地址" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.localFileUrl }}</template>
          </el-table-column>
          <el-table-column label="房间名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.roomName }}</template>
          </el-table-column>
          <el-table-column label="聊天对象编码合并" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.chatObjectUnion }}</template>
          </el-table-column>
          <el-table-column label="文件传输的名字" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.fileName }}</template>
          </el-table-column>
          <el-table-column label="文件传输大小" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.fileSize }}</template>
          </el-table-column> -->
        <el-table-column label="操作" width="135" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="edit(scope.row)" size="small">编辑</el-button> -->
            <el-popconfirm title="确定删除吗？" @confirm="handleDelte(scope.row.id)">
              <el-button slot="reference" type="text">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="(labelType=='add'?'新增':'编辑')" :visible.sync="showDialog" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">

            <el-col :span="12">
              <el-form-item label="：" prop="siteName">
                <el-input v-model="form.id" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息唯一id：" prop="siteName">
                <el-input v-model="form.transactionId" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息归属人编码：" prop="siteName">
                <el-input v-model="form.userCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息归属人名称：" prop="siteName">
                <el-input v-model="form.userName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息接收人编码：" prop="siteName">
                <el-input v-model="form.receiverCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息接收人名称：" prop="siteName">
                <el-input v-model="form.receiverName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息接收人logo：" prop="siteName">
                <el-input v-model="form.receiverLogo" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息发送人编码：" prop="siteName">
                <el-input v-model="form.senderCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息发送人名称：" prop="siteName">
                <el-input v-model="form.senderName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息发送人图片：" prop="siteName">
                <el-input v-model="form.senderLogo" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聊天对象编码：" prop="siteName">
                <el-input v-model="form.chatObjectCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聊天对象名称：" prop="siteName">
                <el-input v-model="form.chatObjectName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聊天对象的logo：" prop="siteName">
                <el-input v-model="form.chatObjectLogo" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="群聊编码：" prop="siteName">
                <el-input v-model="form.groupCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="群聊名称：" prop="siteName">
                <el-input v-model="form.groupName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="群聊图片：" prop="siteName">
                <el-input v-model="form.groupLogo" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息类型：" prop="siteName">
                <el-input v-model="form.messageType" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="传输类型：" prop="siteName">
                <el-input v-model="form.transType" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息内容：" prop="siteName">
                <el-input v-model="form.messageContent" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="发送时间：" prop="siteName">
                <el-input v-model="form.sendTime" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="接收时间：" prop="siteName">
                <el-input v-model="form.receiveTime" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否已读：" prop="siteName">
                <el-input v-model="form.isRead" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息状态：" prop="siteName">
                <el-input v-model="form.messageStatus" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="群成员数量：" prop="siteName">
                <el-input v-model="form.memberCount" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="群管理员编码：" prop="siteName">
                <el-input v-model="form.manageUserCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="群管理员名称：" prop="siteName">
                <el-input v-model="form.manageUserName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="房间号：" prop="siteName">
                <el-input v-model="form.roomId" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聊天对象类型：" prop="siteName">
                <el-input v-model="form.chatObjectType" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="消息类型：" prop="siteName">
                <el-input v-model="form.serviceType" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="已读数量：" prop="siteName">
                <el-input v-model="form.readCount" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="未读数量：" prop="siteName">
                <el-input v-model="form.noReadCount" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="本地url地址：" prop="siteName">
                <el-input v-model="form.localFileUrl" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="房间名称：" prop="siteName">
                <el-input v-model="form.roomName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="聊天对象编码合并：" prop="siteName">
                <el-input v-model="form.chatObjectUnion" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文件传输的名字：" prop="siteName">
                <el-input v-model="form.fileName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文件传输大小：" prop="siteName">
                <el-input v-model="form.fileSize" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 256, //表格高度
      headerHeight: 0
    };
  },

  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight;
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256;
    },

    //获取数据
    getList () {
	  var that = this;
    that.queryInfo.condition.groupCode=localStorage.getItem("chengYuanCircleCode");
	  that.$http.post("/chatInfo/list", that.queryInfo).then(function (response) {
        console.log(response.data.data);
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage=response.data.data.currPage
          that.tableData = response.data.data.data;
        }
      });
    },

    // 保存
    handleSave () {
	    var that = this;
	  that.$http.post("/chatInfo/save", that.form).then(function (response) {
		  if (response.data.code == 200) {
			  that.$notify.success({
				title: "提示",
				message: "保存成功",
				showClose: true,
			  });
			 that.showDialog = false
			  that.getList()
		  }else{
			  that.$notify.info({
				title: "提示",
				message: response.data.message,
				showClose: true,
			  });
		  }
      }).catch(function(error){


      })
	  
	  
    },

    //修改
    edit (row) {
      this.showDialog = true;
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
    },

    // 删除当前行
//    handleDelte (id) {
//      del({ id: id }).then(res => {
//        if (res.code == 200) {
 //         this.$message.success('删除成功')
 //         this.getList()
 //       }
//      })
//    },
	
	// 删除用户
    async handleDelte(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
           var that = this;
        that.$http.post("/chatInfo/delete" ,{"id":id}).then(function (response) {
			if(response.data.code == 200){
			 that.$notify.success({
				title: "提示",
				message: "删除成功",
				showClose: true,
			  });
			  that.getList();
			}else{
				 that.$notify.info({
					title: "提示",
					message: response.data.message,
					showClose: true,
				  });
			}
         
        });
      }
    },

    //新增按钮
    newBtn () {
      this.labelType = 'add'
      this.showDialog = true;
      this.form = {}
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val;
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val;
      this.getList()
    },

  },
};
</script>

<style scoped>
</style>

